var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Pane, Button, Row, Col, PaneFooter, AccordionSet, Accordion, ErrorModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createProductNumber } from "../../api/productNumberService";
import { useResolvedPublisherPrefix } from "../../hooks/useResolvedPublisherPrefix";
import { RecekTextField, RecekSelect, RecekTextArea, } from "../../components/inputs";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createProductNumberSchema } from "../../utils/validationUtils";
import { useModal } from "../../utils/useModal";
import { useAccordion } from "../../utils/useAccordion";
import { ProductNumberCreateRequestAgencyEnum, ProductNumberCreateRequestBlockReasonEnum, ErrorType, } from "../../types/Api";
function ProductNumberCreate() {
    var _this = this;
    var _a;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useForm({
        resolver: zodResolver(createProductNumberSchema(formatMessage)),
        defaultValues: {
            agency: "",
            value: "",
            blockReason: "",
            blockComment: "",
        },
        mode: "onBlur",
    }), handleSubmit = _b.handleSubmit, control = _b.control, watch = _b.watch, errors = _b.formState.errors;
    var _c = useModal(), isOpen = _c.isOpen, message = _c.message, openModal = _c.openModal, closeModal = _c.closeModal;
    var _d = useAccordion({ general: true }), accordionStatus = _d.accordionStatus, toggleAccordion = _d.toggleAccordion;
    var selectedAgency = watch("agency");
    var productNumberValue = watch("value");
    var detectedPublisherPrefix = useResolvedPublisherPrefix(selectedAgency, productNumberValue);
    var onSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var productNumberRequest, error_1, errorMessage, apiError, errorData, errorType, jsonParseError_1, errorText, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 13]);
                    productNumberRequest = {
                        agency: data.agency,
                        value: data.value.replace(/\D/g, ""),
                        blockReason: data.blockReason,
                        blockComment: data.blockComment || undefined,
                    };
                    return [4 /*yield*/, createProductNumber(ky, productNumberRequest)];
                case 1:
                    _c.sent();
                    history.push(navigation.productNumbers.path);
                    return [3 /*break*/, 13];
                case 2:
                    error_1 = _c.sent();
                    console.error("Error creating product number:", error_1);
                    errorMessage = formatMessage({
                        id: "ui-br-agency.product-number.error.submit",
                    });
                    apiError = error_1;
                    if (!apiError.response) return [3 /*break*/, 11];
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 10]);
                    return [4 /*yield*/, apiError.response.json()];
                case 4:
                    errorData = _c.sent();
                    if ((_b = errorData === null || errorData === void 0 ? void 0 : errorData.errors) === null || _b === void 0 ? void 0 : _b[0]) {
                        errorType = errorData.errors[0].type;
                        if (errorType === ErrorType.Value21) {
                            errorMessage = formatMessage({
                                id: "ui-br-agency.product-number.validation.checkDigit",
                            });
                        }
                        else if (errorData.errors[0].message) {
                            errorMessage = errorData.errors[0].message;
                        }
                    }
                    else if (errorData === null || errorData === void 0 ? void 0 : errorData.message) {
                        errorMessage = errorData.message;
                    }
                    return [3 /*break*/, 10];
                case 5:
                    jsonParseError_1 = _c.sent();
                    _c.label = 6;
                case 6:
                    _c.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, apiError.response.text()];
                case 7:
                    errorText = _c.sent();
                    if (errorText) {
                        errorMessage = errorText;
                    }
                    return [3 /*break*/, 9];
                case 8:
                    _a = _c.sent();
                    return [3 /*break*/, 9];
                case 9: return [3 /*break*/, 10];
                case 10: return [3 /*break*/, 12];
                case 11:
                    errorMessage = apiError.message;
                    _c.label = 12;
                case 12:
                    openModal(errorMessage);
                    return [3 /*break*/, 13];
                case 13: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.product-number.create.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, onClick: handleSubmit(onSubmit) },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.push(navigation.productNumbers.path); }, marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: isOpen, label: "Chyba", content: message, onClose: closeModal }),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-agency.product-number.create.pane.title",
                        }), open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "agency", control: control, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-agency.product-number.field.label.agency", value: field.value, required: true, error: (_b = errors.agency) === null || _b === void 0 ? void 0 : _b.message }),
                                            React.createElement("option", { value: "" }, " "),
                                            React.createElement("option", { value: ProductNumberCreateRequestAgencyEnum.ISBN }, "ISBN"),
                                            React.createElement("option", { value: ProductNumberCreateRequestAgencyEnum.ISMN }, "ISMN")));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "value", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.product-number.field.label.value", required: true, error: (_b = errors.value) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }))),
                        detectedPublisherPrefix && (React.createElement(React.Fragment, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12, md: 6 },
                                    React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.field.label.prefixValue", value: detectedPublisherPrefix.value || "", disabled: true, readOnly: true }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12, md: 6 },
                                    React.createElement(RecekTextField, { labelId: "ui-br-agency.product-number.field.label.publisher", value: ((_a = detectedPublisherPrefix.publisher) === null || _a === void 0 ? void 0 : _a.name) || "", disabled: true, readOnly: true }))))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "blockReason", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-agency.product-number.field.label.blockReason", value: field.value, required: true, error: (_b = errors.blockReason) === null || _b === void 0 ? void 0 : _b.message }),
                                            React.createElement("option", { value: "" }, " "),
                                            React.createElement("option", { value: ProductNumberCreateRequestBlockReasonEnum.UNAUTHORIZED_USE }, formatMessage({
                                                id: "ui-br-agency.product-number.blockReason.unauthorizedUse",
                                            })),
                                            React.createElement("option", { value: ProductNumberCreateRequestBlockReasonEnum.PRESUMED_PUBLISHED }, formatMessage({
                                                id: "ui-br-agency.product-number.blockReason.presumedPublished",
                                            }))));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "blockComment", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextArea, __assign({}, field, { labelId: "ui-br-agency.product-number.field.label.blockComment", value: field.value || "" })));
                                    } })))))))));
}
export default ProductNumberCreate;
